export default "__VITE_ASSET__By9Rnqzq__"